// ─── Tracking Layer v2 — Adapters ───
// Adapters de destino para o tracking service. Cada adapter recebe TrackingEvent
// e envia para seu destino.
//
// Este arquivo é um ES module: apenas DEFINE e exporta os adapters. O registro
// acontece em `tracking-bundle.ts`, que os injeta em bootstrapCore() de forma
// síncrona, antes de qualquer evento ser drenado.

// ─── GTM Adapter ───
// Push para window.dataLayer (consumido pelo GTM container).

export const GTMAdapter: TrackingAdapter = {
  name: "gtm",

  send(event: TrackingEvent): void {
    const dl = ((window as any).dataLayer = (window as any).dataLayer || []);
    if (event.payload.event_source === "theme_product_events") dl.push({ ecommerce: null });
    dl.push({
      event: event.name,
      ...event.payload,
      ...event.context,
    });
  },
};

// ─── RudderStack Adapter (stub) ───
// Ativar quando RudderStack SDK estiver carregado no tema.

export const RudderAdapter: TrackingAdapter = {
  name: "rudder",

  init(): void {
    if (!(window as any).rudderanalytics) {
      console.debug("[Tracking][RudderAdapter] rudderanalytics not found — adapter inactive");
    }
  },

  send(event: TrackingEvent): void {
    const ra = (window as any).rudderanalytics;
    if (!ra || typeof ra.track !== "function") return;

    ra.track(event.name, {
      ...event.payload,
      ...event.context,
    });
  },
};
